import { LoaderCircle } from "lucide-react";
import { Outlet } from "react-router-dom";

import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { Alert } from "@tudigo-monorepo/web-tudigo-components";

import { SubscribeClubNavigation } from "./components/subscribe-club-navigation/subscribe-club-navigation";
import { useGetOrCreateClubMember } from "./hooks/use-get-or-create-club-member";
import { useSubscribeClubStepDispatcher } from "./hooks/use-subscribe-club-step-dispatcher";

export function SubscribeClubPage() {
  const { t } = useTranslation();
  const { clubMember, isLoading, isError } = useGetOrCreateClubMember();
  // Redirect user to the correct step (based on the url and server data)
  useSubscribeClubStepDispatcher(clubMember);

  return (
    <div className="z-dialog-overlay fixed left-0 top-0 h-screen w-full overflow-y-auto bg-white">
      <SubscribeClubNavigation />

      {isLoading && !isError && (
        <LoaderCircle className="text-dark-2 mx-auto my-10 h-5 w-5 animate-spin" />
      )}

      {isError && !isLoading && (
        <Alert
          icon="Error"
          variant="error"
          size="S"
          title={t("subscribe_club_page.get_or_create_club_member.error")}
          className="my-10 md:mx-auto md:w-1/2"
        />
      )}

      <Outlet />
    </div>
  );
}
